import { useState } from "react";
import { ChevronDown, ChevronUp, Printer } from "lucide-react";
import { imprimirPdf } from "@/lib/download";
import { toast } from "sonner";

/** Resumen general por empacador: pequeño, en la esquina inferior, se abre y se cierra. */
export const OrgResumen = ({ resumen, query }) => {
  const [abierto, setAbierto] = useState(() => window.innerWidth >= 768);
  return (
    <div className="fixed bottom-3 right-3 z-30 w-[calc(100%-1.5rem)] max-w-[720px] rounded-xl border-2 border-[#F59E0B] bg-white shadow-2xl" data-testid="org-resumen">
      <div className="flex items-center justify-between bg-[#F59E0B] text-white px-3 py-1.5 rounded-t-lg">
        <button onClick={() => setAbierto((x) => !x)} className="font-black text-base" data-testid="org-resumen-toggle">Resumen general por empacador</button>
        <div className="flex items-center gap-2">
          <button onClick={() => imprimirPdf(`/organizador/resumen-empacador.pdf?${query}`).catch((e) => toast.error(String(e.message || e)))} title="Imprimir resumen" data-testid="org-resumen-imprimir"><Printer className="w-5 h-5" /></button>
          <button onClick={() => setAbierto((x) => !x)} aria-label="Abrir o cerrar">{abierto ? <ChevronDown className="w-5 h-5" /> : <ChevronUp className="w-5 h-5" />}</button>
        </div>
      </div>
      {abierto && (
        <div className="max-h-52 overflow-y-auto divide-y divide-zinc-100">
          {resumen.length === 0 && <div className="px-3 py-2 text-sm text-zinc-500">Sin productos en este filtro.</div>}
          {resumen.map((e) => (
            <div key={e.empacador} className="grid grid-cols-[90px_1fr_1fr] sm:grid-cols-[110px_repeat(6,auto)] gap-x-3 gap-y-0.5 items-center px-3 py-1.5 text-[12px]" data-testid={`org-resumen-${e.empacador}`}>
              <b className="uppercase text-[13px] truncate">{e.empacador}</b>
              <span>Pedidos: {e.pedidos}</span><span>Productos: {e.productos}</span><span>Paquetes: {e.paquetes}</span>
              <b className="text-emerald-700">Empacados: {e.empacados}</b><b className="text-amber-600">Parciales: {e.parciales}</b><b className="text-red-600">Pendientes: {e.pendientes}</b>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
